import queryString from 'querystring'

import React, { useState } from 'react'
import { mapLocationGroupsQuery_mapLocationGroups } from 'components/pages/MarketPage/TrucksMap/types/mapLocationGroupsQuery'
import { LocationMarkerIcon } from '@heroicons/react/outline'
import Image from 'components/Image'
import Button from 'components/ui/Button'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

export type MapProps = {
  defaultCenter: MapCenterType
  groups: mapLocationGroupsQuery_mapLocationGroups[]
  scale?: number
  showInNewPage?: boolean
}

type DynamicMapProps = {
  staticMap: React.ReactElement
  defaultCenter: MapCenterType
  height: number
  zoom: number
  groups: mapLocationGroupsQuery_mapLocationGroups[]
}
const DynamicMap = dynamic<DynamicMapProps>(() =>
  import('./DynamicMap').then((mod) => mod.default)
)

const MAPS_KEY = 'AIzaSyDBXkdl95KlS2SmNfQfHYQRGMic6USqegw'

export type MapCenterType = { lat: number; lng: number }
export type MapContainerProps = { height: number }

const Map = ({
  height,
  defaultCenter,
  groups,
  scale = 2,
  showInNewPage
}: MapProps & MapContainerProps) => {
  const router = useRouter()
  const [useDynamicMap, setUseDynamicMap] = useState<boolean>(false)

  const staticImage = (
    <Image
      alt="Map of trucks"
      layout="fill"
      objectFit="cover"
      objectPosition="50% 50%"
      quality={50}
      src={`https://maps.googleapis.com/maps/api/staticmap?${queryString.encode(
        {
          center: `${defaultCenter.lat},${defaultCenter.lng}`,
          zoom: 9,
          size: `${640}x${height}`,
          key: MAPS_KEY,
          scale,
          format: 'jpg',
          markers: `color:red|size:mid|${groups
            .map((g) => `${g.latitude},${g.longitude}`)
            .join('|')}`
        }
      )}`}
      priority
    />
  )
  const staticMap = (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events
    <div
      className="cursor-pointer relative"
      onClick={() => {
        if (showInNewPage) {
          router.push('/food-trucks-map')
        } else {
          setUseDynamicMap(true)
        }
      }}
      role="button"
      style={{ height }}
    >
      {staticImage}
      <div className="flex justify-center items-center h-full relative">
        <div className="absolute bg-black opacity-30 h-full w-full" />
        {!useDynamicMap && (
          <Button
            className="absolute"
            color="primary"
            onClick={(e) => {
              e.stopPropagation()

              if (showInNewPage) {
                router.push('/food-trucks-map')
              } else {
                setUseDynamicMap(true)
              }
            }}
            size="large"
            variant="contained"
            shadow
          >
            <LocationMarkerIcon className="w-5 h-5 mr-1 text-white" />{' '}
            <p className="whitespace-nowrap">Browse Trucks</p>
          </Button>
        )}
      </div>
    </div>
  )
  if (!useDynamicMap) return staticMap

  return (
    <DynamicMap
      defaultCenter={defaultCenter}
      groups={groups}
      height={height}
      staticMap={staticMap}
      zoom={10}
    />
  )
}

export default Map
